import { CardConfiguration } from './card-configuration';
import { TranslateHandlebarsPipe } from 'app/shared/pipes/translate-handlebars.pipe';
import { CertificateService } from 'app/core/components/content/certificate/certificate.service';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';

declare var moment: any;

export class ExamCardConfiguration extends CardConfiguration {
    constructor(course: any, translateHandlebarsPipe: TranslateHandlebarsPipe, certificateService: CertificateService, ) {
        super();
        // console.log(course);
        let hoursSinceRelease = moment.duration(moment().diff(moment(course.releaseDate, "YYYY.MM.DD HH:mm").toDate())).asHours();
        this.tagType = 'exam';
        this.classType = (hoursSinceRelease <= 72 && !course.expired) ? 'New Exam' : 'Exam';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/courseware.png';
        this.expired = course.expired;
        this.clickable = false;
        this.target = [];
        this.links = course.productVariant && course.productVariant.hosted &&
            course.certificate && course.certificate.certLocation ? [{
                disabled: !course.certificate || !course.certificate.certLocation,
                tooltip: !course.certificate || !course.certificate.certLocation ?
                    'branded.portal.courses.exam.material.tooltip.text' : null,
                url: [],
                type: LinkActions.ACTION,
                action: (assignment) => certificateService.getCertificateFile(course.certificate.certLocation, course.certificate.displayName),
                text: translateHandlebarsPipe.transform('branded.portal.courses.exam.material.text', course),
                image: !course.certificate.certLocation ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/file-certificate-inactive.svg' :
                    'https://itpx-branded-portal-dev.s3.amazonaws.com/file-certificate.svg'
            }] : [];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/exam-card-configuration.ts